export default __webpack_public_path__ + "14f9c47841a0425190369a0a206aa642.png";